/**
 * @extends com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.CMSDKCommunicationMessageHandler = function() {
	this.constructor.__super__.call(
		this,
		com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION
	);
	
	/** @type {object} */
	this.xssModule = require("xss");
};
$hxClasses.extend(
	com.inq.flash.client.control.messagehandlers.ChatCommunicationMessageHandler,
	com.inq.flash.client.control.messagehandlers.CMSDKCommunicationMessageHandler,
	"com.inq.flash.client.control.messagehandlers.CMSDKCommunicationMessageHandler"
);

com.inq.flash.client.control.messagehandlers.CMSDKCommunicationMessageHandler.prototype.processMessage = function(message) {

	/** @type {?string} */
	var agentId;
	/** @type {string} */
	var senderName;
	var replay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY);
	var senderName;

	var agentName;
	if (message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ALIAS)) {
		agentName = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ALIAS);
	} else {
		agentName = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_AGENT_ALIAS);
	}
	if (!agentName) {
		agentName = com.inq.flash.client.control.FlashVars.getFlashVars().agentName;
	}
	var clientName = com.inq.flash.client.control.FlashVars.getCustomerName();

	if (message.getMessageType() == com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_QUEUE) {
		this.getController().setFlagChatInQueue(true);
		com.inq.flash.client.control.FlashPeer.onQueueWaitMsg();
		agentId = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ALIAS);
	} else {
		agentId = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ID);
	}
	var chatTextKey = message.getMessageType() == com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OUTCOME ? com.inq.flash.client.data.MessageFields.KEY_CLIENT_OUTCOME_DATA : com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA;
	/** @type {string} */
	var chatText = message.getProperty(chatTextKey);
	var isAgentMessage = !!agentId;

	chatText = this.getFilteredText(chatText);

	//In case of a URL in the agent message it will be converted to an anchor tag because for accessibility user URL's has to be in the tab order
	//(only applies to urls that are not in tags)
	if (isAgentMessage && com.inq.utils.Util.URL_REGEX.test(chatText)) {
		chatText = chatText.replace(com.inq.utils.Util.URL_REGEX, "<a href=\"$&\" target=\"_blank\">$&</a>");
	}
	chatText = this.handleCustomEventAttributes(chatText);
	if (message.getProperty(com.inq.flash.client.data.MessageFields.FORM_DATA) == null) {
		if (message.getMessageType() === com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OUTCOME
			|| message.getMessageType() === com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OPENER
		) {
			senderName = agentName;
		} else {
			senderName = isAgentMessage ? agentName : clientName;
		}
	} else {
		senderName = "";
	}

	if (message.getMessageType() != com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OPENER && !replay) {
		if (message.getMessageType() == com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION) {
			if (isAgentMessage && message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_AUTO_OPENER) !== "true") {
				com.inq.flash.client.control.Incrementality.onInteracted();
				/* If the onInteracted has been performed before, it will return */
				com.inq.flash.client.control.Incrementality.onAgentMsg(chatText);
			}
			else if (com.inq.flash.client.control.FlashVars.getCustomerName() === senderName) {
				com.inq.flash.client.control.Incrementality.onCustomerMsg(chatText);
			}
		}

		if (isAgentMessage) {
			this.getController().setFlagChatInQueue(false);
			com.inq.flash.client.control.MinimizeManager.lastAgentMessage(chatText);
		}
	}

	message.addProperty(com.inq.flash.client.control.messagehandlers.CMSDKCommunicationMessageHandler.SENDER_NAME, senderName);
	message.addProperty(com.inq.flash.client.control.messagehandlers.CMSDKCommunicationMessageHandler.IS_AGENT_MESSAGE, isAgentMessage);
	message.addProperty(com.inq.flash.client.control.messagehandlers.CMSDKCommunicationMessageHandler.CHAT_FINAL_TEXT, chatText);

	this.getController().onNewChatRouterMessage(message);
};

/** @type {string} */
com.inq.flash.client.control.messagehandlers.CMSDKCommunicationMessageHandler.SENDER_NAME = "senderName";
com.inq.flash.client.control.messagehandlers.CMSDKCommunicationMessageHandler.IS_AGENT_MESSAGE = "isAgentMsg";
com.inq.flash.client.control.messagehandlers.CMSDKCommunicationMessageHandler.CHAT_FINAL_TEXT = "chatFinalText";
